import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem } from '@/ui';
import { PhoneNumber } from '@ngsos/portal-core/incidents';
import { openPhoneNumberDialog } from '../../actions';

export type PhoneNumberPanelItemProps = {
  incidentId: string;
  phoneNumber: string | null;
  editable?: boolean;
};

export function PhoneNumberPanelItem({ incidentId, phoneNumber, editable = false }: PhoneNumberPanelItemProps) {
  const { t } = useTranslation();

  if (phoneNumber === null) {
    return (
      <DataPanelInlineItem
        title={t('Incident_InfoPanel_Phone')}
        editable={editable}
        showEmptyPlaceholder
        onEditClick={() => openPhoneNumberDialog(incidentId)}
      />
    );
  }

  const parsed = PhoneNumber.tryInitialize(phoneNumber);

  return (
    <DataPanelInlineItem
      title={t('Incident_InfoPanel_Phone')}
      value={parsed?.toFormattedString() ?? phoneNumber}
      allowCopyToClipboard
      linkUrl={parsed?.getUrlForCall() ?? `tel:${phoneNumber}`}
      valueToCopy={phoneNumber}
      testID="incident-caller-phone-link"
    />
  );
}
